(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormDetailController', EventFormDetailController);

    EventFormDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventForm', 'EventFormAttachmentService', 'Principal', 'AlertService', '$window', 'EquipmentParc', '$translate'];

    function EventFormDetailController($scope, $rootScope, $stateParams, entity, EventForm, EventFormAttachmentService, Principal, AlertService, $window, EquipmentParc, $translate) {
        var vm = this;

        vm.eventForm = entity;
        vm.history = [];
        vm.linkedEquipment = [];
        vm.attachments = [];
        vm.eventLoaded = false;
        vm.hasFormValidationRight = false;
        vm.hasEditRight = false;
        vm.selectedAttachmentFile = null;
        vm.selectedAttachmentFileName = null;

        vm.statusLabel = statusLabel;
        vm.reasonLabel = reasonLabel;
        vm.validateDocument = validateDocument;
        vm.controlDocument = controlDocument;
        vm.createTicket = createTicket;
        vm.canValidate = canValidate;
        vm.canControl = canControl;
        vm.setAttachmentFile = setAttachmentFile;
        vm.uploadAttachment = uploadAttachment;
        vm.downloadAttachment = downloadAttachment;

        Principal.identity().then(function(account) {
            var authorities = account && account.authorities ? account.authorities : [];
            vm.canReadEquipment = account && account.modules && account.modules.indexOf('EQUIPMENT') >= 0 && ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS'].some(function (role) { return authorities.indexOf(role) >= 0; });
            vm.canCreateEquipment = vm.canReadEquipment && ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_EQUIPMENT_EDIT'].some(function (role) { return authorities.indexOf(role) >= 0; });
            loadLinkedEquipment(resolveEventId());
            vm.hasFormValidationRight = authorities.indexOf('ROLE_FORM_VALIDATION') !== -1;
            vm.hasEditRight = authorities.indexOf('ROLE_EVT_EDIT') !== -1
                || authorities.indexOf('ROLE_ADMIN') !== -1
                || authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
        });

        vm.load = function(id) {
            EventForm.get({id: id}, function(result) {
                setEventForm(result);
            });
            loadHistory(id);
            loadAttachments(id);
        };

        if (vm.eventForm && vm.eventForm.$promise) {
            vm.eventForm.$promise.then(function(result) {
                setEventForm(result);
            });
        } else if (vm.eventForm) {
            setEventForm(vm.eventForm);
        }

        var unsubscribe = $rootScope.$on('wamasysApp:eventFormUpdate', function(event, result) {
            setEventForm(result);
        });
        $scope.$on('$destroy', unsubscribe);

        function setEventForm(eventForm) {
            prepareEventForm(eventForm);
            vm.eventForm = eventForm;
            vm.eventLoaded = !!resolveEventId();
            if (vm.eventLoaded) {
                loadHistory(resolveEventId());
                loadAttachments(resolveEventId());
                loadLinkedEquipment(resolveEventId());
            }
        }

        function loadLinkedEquipment(id) {
            if (!id || !vm.canReadEquipment) { return; }
            EquipmentParc.get('for-event/' + id).then(function (links) { vm.linkedEquipment = links; }, angular.noop);
        }

        function loadHistory(id) {
            if (!id) {
                vm.history = [];
                return;
            }
            EventForm.history({id: id}, function(result) {
                vm.history = result;
            });
        }

        function loadAttachments(id) {
            if (!id) {
                vm.attachments = [];
                return;
            }
            EventFormAttachmentService.query(id).then(function(response) {
                vm.attachments = response.data || [];
            }, function(error) {
                vm.attachments = [];
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.attachmentsLoadError'));
            });
        }

        function validateDocument() {
            var eventId = resolveEventId();
            if (!eventId) {
                return;
            }
            vm.statusActionInProgress = true;
            EventForm.validateDocument({id: eventId}, function(result) {
                vm.statusActionInProgress = false;
                AlertService.success($translate.instant('wamasysApp.eventForm.validated'));
                setEventForm(result);
            }, onActionError);
        }

        function controlDocument() {
            var eventId = resolveEventId();
            if (!eventId) {
                return;
            }
            vm.statusActionInProgress = true;
            EventForm.controlDocument({id: eventId}, function(result) {
                vm.statusActionInProgress = false;
                AlertService.success($translate.instant('wamasysApp.eventForm.controlled'));
                setEventForm(result);
            }, onActionError);
        }

        function createTicket() {
            var eventId = resolveEventId();
            if (!eventId) {
                return;
            }
            vm.ticketActionInProgress = true;
            EventForm.createTicket({id: eventId}, function(result) {
                vm.ticketActionInProgress = false;
                AlertService.success($translate.instant('wamasysApp.eventForm.ticketCreated'));
                if (result && result.url) {
                    $window.open(result.url, '_blank');
                }
            }, onActionError);
        }

        function setAttachmentFile(file) {
            vm.selectedAttachmentFile = file || null;
            vm.selectedAttachmentFileName = file && file.name ? file.name : null;
        }

        function uploadAttachment() {
            if (!vm.eventLoaded || !vm.selectedAttachmentFile) {
                return;
            }
            vm.attachmentUploadInProgress = true;
            EventFormAttachmentService.upload(vm.eventForm.id, vm.selectedAttachmentFile).then(function() {
                vm.attachmentUploadInProgress = false;
                vm.selectedAttachmentFile = null;
                vm.selectedAttachmentFileName = null;
                AlertService.success($translate.instant('wamasysApp.eventForm.attachmentAdded'));
                loadAttachments(vm.eventForm.id);
            }, function(error) {
                vm.attachmentUploadInProgress = false;
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.attachmentUploadError'));
            });
        }

        function downloadAttachment(attachment) {
            if (!vm.eventLoaded || !attachment || !attachment.id) {
                return;
            }
            EventFormAttachmentService.download(vm.eventForm.id, attachment.id).then(function(result) {
                var fileName = result.fileName || attachment.fileName || 'piece-jointe';
                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(result.response, fileName);
                    return;
                }
                var url = ($window.URL || $window.webkitURL).createObjectURL(result.response);
                var link = angular.element('<a/>');
                link.attr('href', url);
                link.attr('download', fileName);
                angular.element(document.body).append(link);
                link[0].click();
                link.remove();
                ($window.URL || $window.webkitURL).revokeObjectURL(url);
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.attachmentDownloadError'));
            });
        }

        function onActionError(error) {
            vm.statusActionInProgress = false;
            vm.ticketActionInProgress = false;
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError'));
        }

        function canValidate() {
            return vm.eventLoaded && vm.hasFormValidationRight && vm.eventForm.workflowStatus === 'SUBMITTED';
        }

        function canControl() {
            return vm.eventLoaded && vm.hasFormValidationRight && vm.eventForm.workflowStatus === 'VALIDATED';
        }

        function prepareEventForm(eventForm) {
            if (!eventForm) {
                return;
            }
            eventForm.answerFields = [];
            var fieldLabels = buildFieldLabels(eventForm.subCategoryCustomFields);
            var rawAnswers = eventForm.answersJson;
            if (!rawAnswers) {
                return;
            }
            try {
                var answers = angular.fromJson(rawAnswers);
                angular.forEach(answers, function(value, key) {
                    eventForm.answerFields.push({
                        label: fieldLabels[key] || key,
                        code: key,
                        value: value
                    });
                });
            } catch (e) {
                console.log(e);
            }
        }

        function statusLabel(status) {
            var labels = {
                DRAFT: $translate.instant('wamasysApp.eventForm.statuses.DRAFT'),
                SUBMITTED: $translate.instant('wamasysApp.eventForm.statuses.SUBMITTED'),
                VALIDATED: $translate.instant('wamasysApp.eventForm.statuses.VALIDATED'),
                CONTROLLED: $translate.instant('wamasysApp.eventForm.statuses.CONTROLLED'),
                DELETED: $translate.instant('wamasysApp.eventForm.statuses.DELETED')
            };
            return labels[status] || status;
        }

        function reasonLabel(reason) {
            var labels = {
                MANUAL_CORRECTION: $translate.instant('wamasysApp.eventForm.reasons.MANUAL_CORRECTION'),
                AUTO_CORRECTION: $translate.instant('wamasysApp.eventForm.reasons.AUTO_CORRECTION'),
                COMPLEMENTARY_INFO_ADDED: $translate.instant('wamasysApp.eventForm.reasons.COMPLEMENTARY_INFO_ADDED')
            };
            return labels[reason] || reason;
        }

        function resolveEventId() {
            if (vm.eventForm && vm.eventForm.id) {
                return vm.eventForm.id;
            }
            return $stateParams && $stateParams.id ? $stateParams.id : null;
        }

        function buildFieldLabels(customFieldsJson) {
            var labels = {};
            if (!customFieldsJson) {
                return labels;
            }
            try {
                var config = angular.fromJson(customFieldsJson);
                angular.forEach((config && config.fields) || [], function(field) {
                    var label = field.label || field.dictionaryFieldCode || field.name || field.code;
                    if (!label) {
                        return;
                    }
                    angular.forEach([field.name, field.code, field.dictionaryFieldCode].concat(parseLegacyNames(field.legacyNames || field.legacyCodes)), function(candidate) {
                        if (candidate && !labels[candidate]) {
                            labels[candidate] = label;
                        }
                    });
                });
            } catch (e) {
                console.log(e);
            }
            return labels;
        }

        function parseLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value;
            }
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }
    }
})();
